// extracted by mini-css-extract-plugin
module.exports = {"headerExpand":"PostList_headerExpand__2HHbq","headerExpandText":"PostList_headerExpandText__OgV0j"};